var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9902 18H13.0002V11C13.0002 10.447 12.5522 9.99996 12.0002 9.99996H6.00018C5.44718 9.99996 5.00018 10.447 5.00018 11V18H2.00018L2.00618 9.58296L8.99818 2.43196L16.0002 9.62396L15.9902 18ZM7.00018 18H11.0002V12H7.00018V18ZM17.4242 8.18496L9.71518 0.300957C9.33818 -0.084043 8.66218 -0.084043 8.28518 0.300957L0.575183 8.18596C0.210183 8.56096 0.000183105 9.08496 0.000183105 9.62396V18C0.000183105 19.103 0.847183 20 1.88818 20H6.00018H12.0002H16.1112C17.1522 20 18.0002 19.103 18.0002 18V9.62396C18.0002 9.08496 17.7902 8.56096 17.4242 8.18496Z",
    fill: "#757D8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.43d3ca373e6ba8625ba1304903761dce.svg";
export { ForwardRef as ReactComponent };